import {Component, Injector} from '@angular/core';
import {PopupState, Store as PopupStore} from './state/store';
import {Popup} from './state/model';
import {PopupService as PopupService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {PopupQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class PopupDetailComponent extends EntityDetailComponent<Popup, PopupState, PopupStore> {

  constructor(
    public injector: Injector,
    service: PopupService,
    protected query: PopupQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
